module.exports = __webpack_public_path__ + "img/productRateDescription2.56041f42.png";